// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2173ca18307d46c2dd8345aeb46db79d9c34bc4e.chunk.bundle.js";
};